// removed by extract-text-webpack-plugin
module.exports = {"pagination":"pagination_30K3g","spreads":"spreads_3oxR0","nav":"nav_32xwX","navIcon":"navIcon_7eeS1","disabled":"disabled_1CV-L","pageMargin":"pageMargin_26liD","left":"left_24Ktt","right":"right_Laeuo"};


//////////////////
// WEBPACK FOOTER
// ./app/components/pagination/styles.scss
// module id = 492
// module chunks = 1